import React from "react";
import HighlightedText from "./HighlightedText";
import DotSeparator from "../DotSeparator";

const ITEM_ID_LABELS = {
	Document: "Document ID",
	Email: "Email ID",
	"Matter Note": "Note ID",
};

// Same bold treatment used for labels throughout the app (e.g.
// CitationsSidebar) — makes the label stand out from the value next to it.
const BoldLabel = ({ children }) => (
	<span style={{ fontFamily: "MainFont-Bold" }}>{children}</span>
);

// Renders a row's "ID: X" / "Document ID: Y" text (plus "Custom ID: Z" for
// a Matter that has one) — labels are bold and never highlight themselves;
// only each ID's own value can match `highlightQuery`.
const ContextItemIdText = ({ item, highlightQuery }) => {
	if (item.itemType === "Matter") {
		return (
			<>
				<BoldLabel>ID:</BoldLabel>{" "}
				<HighlightedText text={item.id} query={highlightQuery} />
				{item.customMatterID ? (
					<>
						<DotSeparator />
						<BoldLabel>Custom ID:</BoldLabel>{" "}
						<HighlightedText
							text={item.customMatterID}
							query={highlightQuery}
						/>
					</>
				) : null}
			</>
		);
	}
	const idLabel = ITEM_ID_LABELS[item.itemType] || "ID";
	return (
		<>
			<BoldLabel>{idLabel}:</BoldLabel>{" "}
			<HighlightedText text={item.id} query={highlightQuery} />
		</>
	);
};

export default ContextItemIdText;
